import refChangesFields from "@/../public/data/reference-changes.json";
import _ from "lodash";

export default {
    generateInstrumentItems () {
      const items = []
      const data = this.equityData
      
      for (let i = 0; i < data.length; i++) {
        items.push([
          data[i]["int_ric"],
          data[i]["int_security_description"],
          data[i]["int_company_short_name"],
          data[i]["int_asset_status"],
          data[i]["int_currency_code"],
          data[i]["int_cusip"],
          data[i]["int_isin"],
          data[i]["int_sedol"],
          data[i]["int_trbc_industry_code"],
          data[i]["int_share_class"],
          data[i]["int_quote_perm_id"],
          data[i]["int_issue_perm_id"]
        ])
      }
      if(items.length == 0){
        this.equityResults = false;
      }else{
        this.equityResults = true;
      }
      return items
    },
    generateEquityReferenceChangesItems () {
      let items = []
      const refData = this.refChangesData
      const fields = refChangesFields
      var refData2 = this.refFieldsData.pop()
      for (let d of refData) {
        fields.forEach(function (field){
          if(d["ref_"+field+"_change_flag"] == "Y"){  
            let action = ""
            if(d["ref_action"] == "U"){
              action = "Update"
            }else if(d["ref_action"] == "D"){
              action = "Delete"
            }else if(d["ref_action"] == "I"){
              action = "Insert"
            }
            items.push([
              d["ref_dsp_st_publish_date"],
              Number(d["ref_dsp_st_publish_segment"]),
              action,
              field,
              d["ref_"+field+"_previous"],
              d["ref_"+field]
            ])
          }
        })
      }
      items = _.uniqWith(items, _.isEqual)
      if(items.length < 1){
        this.refChangesFlag = false;
      }
      this.sampleEquityReferenceChanges = items
      for(let item of items){
        refData2["int_"+item[3]] = item[5]
      }
      this.refFieldsArray = refData2
      this.equityReferenceChangesItems = items
      return items
    },
    
    generateEquityPricingItems () {
      let items = []
      const price_data = this.pricingData
      function formatDate(date){
        let d = date.slice(0,4)+"-"+date.slice(4,6)+"-"+date.slice(6,8)
        return d
      }
      function uniq(d) {
        console.log("pricing check",d)
        return d
          .sort(function compare(a, b) {
            var dateA = new Date(a[0]);
            var dateB = new Date(b[0]);
            return dateA - dateB;
          })
          .filter(function (item, pos, ary) {
            return !pos || item[0] != ary[pos - 1][0];
          });
      }
      for (let i = 0; i < price_data.length; i++) {
        items.push([
          formatDate(price_data[i]["prc_trade_date"]),
          price_data[i]["prc_ask_price"],
          price_data[i]["prc_bid_price"],
          price_data[i]["prc_open_price"],
          price_data[i]["prc_high_price"],
          price_data[i]["prc_low_price"],
          price_data[i]["prc_universal_close_price"],
          price_data[i]["prc_volume"]
        ])
      }
      items = uniq(items)
      return items
    },
    
    generateEquityCorporateActionsReferenceChangesItems (maxItems) {
      const items = []
      for (let i = 0; i < maxItems; i++) {
        items.push([
          `Timestamp ${i + 1}`,
          `Update`,
          `${this.equityCorporateActionsReferenceFields[this.getRandomInt(0, this.equityCorporateActionsReferenceFields.length - 1)]}`,
          `Previous value ${i + 1}`,
          `Current value ${i + 1}`
        ])
      }
      return items
    },
    
    generateEquityCorporateActionsEventItems (maxItems) {
      const items = []
      const levels = ['A', 'Q', 'A', 'A', 'Q']
      const paritions = ['Restructure', 'AdditionalInformation', 'CorporateActionDetails', 'GeneralDetails', 'IntermediateSecurities', 'MarketDetails']
      for (let i = 0; i < maxItems; i++) {
        items.push([
          `Event ${i + 1}`,
          levels[this.getRandomInt(0, levels.length - 1)],
          paritions[this.getRandomInt(0, paritions.length - 1)],
          `Parent ${i + 1}`,
          i + 1,
          `Adjustment Factor ${i + 1}`,
          `Announcement Date ${i + 1}`,
          `Effective Date ${i + 1}`,
          `Meeting Date ${i + 1}`,
          `Meeting End Date ${i + 1}`,
          `Meeting Agenda ${i + 1}`,
          `Ex Date ${i + 1}`,
          `Payment Date ${i + 1}`,
        ])
      }
      return items
    },
    
    generateEquityCorporateActionsEventChangesItems (maxItems) {
      const items = []
      for (let i = 0; i < maxItems; i++) {
        items.push([
          `Timestamp ${i + 1}`,
          `Update`,
          `${this.equityCorporateActionsEventFields[this.getRandomInt(0, this.equityCorporateActionsEventFields.length - 1)]}`,
          `Previous value ${i + 1}`,
          `Current value ${i + 1}`
        ])
      }
      return items
    },
}